import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import SellerCard from '@fiverr-private/seller_card/src/SellerCard';
import PortfolioShowcase from '@fiverr-private/portfolio_showcase/src/PortfolioShowcase';
import FiverrLearn from '@fiverr-private/fiverr_learn/src/components';
import ProVerified from '@fiverr-private/pro_verified/src/components';
import WithImpressions from '../WithImpressions';
import { MODAL_WRAPPER_CLASS } from '../constants';
import CouponBomba from '../CouponBomba';
import { QUALAS_USER_PAGE_LOYALTY_BANNER } from '../../../experiments/experimentsEnum';
import { isAllocated } from '../../../experiments';
import LoyaltySellerBanner from './LoyaltyBanner';
import SellerProfile from './SellerProfile';
import ScrollTo from './scrollTo';
import { biHelper } from './biHelper';

import './index.scss';

const InfoPanel = ({
    sellerCard = {},
    proSubCategories = [],
    portfolioProjects = {},
    fiverrLearnCourses = [],
    sellerProfile = {},
    skillTests,
    onPortfolioClick,
    scrollComponents,
    pageCtxId = '',
    currentUserNumberedId: buyerId,
    coupon,
    repeatScore,
    handleLoyaltyBannerView
}) => {
    const { locale } = getContext();
    const hasPortfolioProjects = !!portfolioProjects.portfolioProjectsThumbs.length;
    const { id: sellerId, is_pro: isPro, username } = sellerCard.user;

    let aboutRef;
    let position = 0;

    const baseBiData = {
        sellerId,
        buyerId,
        pageCtxId
    };

    const showLoyaltySellerBannerExperiment = () => {
        const { isMobile, abTests = {}, locale = DEFAULT_LOCALE } = getContext();

        return !isMobile &&
            (locale === DEFAULT_LOCALE) &&
            !_.isEmpty(repeatScore) &&
            isAllocated(QUALAS_USER_PAGE_LOYALTY_BANNER, abTests);
    };

    isPro && position++;
    const pro_skills_impression = biHelper({
        ...baseBiData,
        position,
        data: proSubCategories,
        group: 'seller_card_fiverr_pro_skills_verified_impression'
    });

    position++; // increase value for the seller card

    hasPortfolioProjects && position++;
    const my_protfolio_impression = biHelper({
        ...baseBiData,
        position,
        group: 'seller_card_my_protfolio_impression'
    });

    !_.isEmpty(fiverrLearnCourses) && position++;
    const fiverr_learn_impression = biHelper({
        ...baseBiData,
        position,
        data: fiverrLearnCourses,
        group: 'seller_card_fiverr_learn_impression'
    });

    const campaignLinkParams = `referrer=seller_card&ref_ctx_id=${pageCtxId}`;

    const showScrollTo = scrollComponents && !_.isEmpty(scrollComponents);

    return (
        <div className="info-panel col-12-xs col-5-md col-4-lg">

            {isPro &&
                <WithImpressions pageCtxId={pageCtxId} value={pro_skills_impression}>
                    <ProVerified linkParams={campaignLinkParams}
                        pro_sub_categories={proSubCategories}
                        locale={locale}/>
                </WithImpressions>
            }
            <SellerCard {...sellerCard} modalWrapperClass={MODAL_WRAPPER_CLASS} locale={locale}/>
            {showLoyaltySellerBannerExperiment() &&
                <LoyaltySellerBanner sellerName={username}
                    sellerId={sellerId}
                    handleLoyaltyBannerView={handleLoyaltyBannerView}/>
            }

            {coupon && coupon.discountValue && <CouponBomba className="mobile"
                ignoreOnMountEvents
                coupon={coupon}
                sellerId={sellerId}
                userId={buyerId}/>}

            {showScrollTo &&
                <ScrollTo scrollComponents={scrollComponents}
                    aboutScrollFunc={() => aboutRef.scrollIntoView({ block: 'start', behavior: 'smooth' })}/>
            }

            {showScrollTo &&
                <div ref={(ref) => (aboutRef = ref)}/>
            }

            {hasPortfolioProjects &&
                <WithImpressions pageCtxId={pageCtxId} value={my_protfolio_impression}>
                    <PortfolioShowcase {...portfolioProjects} onClick={onPortfolioClick}/>
                </WithImpressions>
            }

            {!_.isEmpty(fiverrLearnCourses) &&
                <WithImpressions pageCtxId={pageCtxId} value={fiverr_learn_impression}>
                    <FiverrLearn courses={fiverrLearnCourses} selfview={false}/>
                </WithImpressions>
            }

            <SellerProfile {...sellerProfile}
                skillTests={skillTests}
                biData={{ ...baseBiData, initialCounter: position }}/>
        </div>
    );
};

InfoPanel.propTypes = {
    sellerCard: PropTypes.object,
    portfolioProjects: PropTypes.object,
    fiverrLearnCourses: PropTypes.array,
    proSubCategories: PropTypes.array,
    sellerProfile: PropTypes.object,
    onPortfolioClick: PropTypes.func,
    scrollComponents: PropTypes.array,
    pageCtxId: PropTypes.string,
    coupon: PropTypes.shape({
        couponId: PropTypes.string.isRequired,
        couponType: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        discountValue: PropTypes.number.isRequired,
        providerName: PropTypes.string.isRequired
    })
};

export default InfoPanel;
